import React from "react";

const ViewNews = () => {
  return <div>view news</div>;
};

export default ViewNews;
